export const DUMMY_SECTIONS_TEAM_GOALS = [
  {
    isDummy: true,
    coverProps: {
      height: '4rem',
      width: '100%',
      position: {}
    }
  },
  {
    isDummy: true,
    coverProps: {
      height: 'calc(100% - 4rem)',
      width: '14rem',
      position: { top: '4rem' }
    }
  },
  {
    isDummy: true,
    coverProps: {
      height: '20rem',
      width: 'calc(100% - 38rem)',
      position: { top: '4rem', left: '38rem' }
    }
  },
  {
    isDummy: true,
    coverProps: {
      height: '5.45rem',
      width: 'calc(100% - 14rem)',
      position: { bottom: 0, left: '14rem' }
    }
  },
  {
    isDummy: true,
    coverProps: {
      height: 'calc(100% - 29.45rem)',
      width: 'calc(43% - 14rem)',
      position: { bottom: '5.45rem', left: '14rem' }
    }
  }
];
